@for (tree of trees; track tree; let index = $index) {
    <fui-navigation-tree id="tree-{{index}}" [tree]="tree"></fui-navigation-tree>
}
